import type { MfaFactor, MfaFactorStatus } from "./types";

// Shape of the `detail` field on MFA enrollment error responses (see BE docs:
// CODE_MISMATCH / INVALID_MFA_TYPE / COGNITO_ERROR).
export interface MfaErrorDetail {
  code: string;
  message: string;
}

// Enrollment verification errors (wrong TOTP/SMS code) come back as
// `{ detail: { code, message } }`, not a plain string — pull that out so
// callers can show `message` inline instead of a generic fallback.
export const getMfaErrorDetail = (
  error: unknown
): MfaErrorDetail | undefined => {
  const detail = (
    error as { response?: { data?: { detail?: unknown } } } | undefined
  )?.response?.data?.detail;
  return detail && typeof detail === "object" && "code" in detail
    ? (detail as MfaErrorDetail)
    : undefined;
};

// GET /users/me/mfa/factors always returns the Totp/Sms factors (plus a
// legacy Email one we no longer offer in the UI), but fall back to an
// unenrolled placeholder in case one is ever missing from the response.
export const findMfaFactor = (
  factors: MfaFactorStatus[] | undefined,
  factor: MfaFactor
): MfaFactorStatus =>
  factors?.find((status) => status.factor === factor) ?? {
    factor,
    enabled: false,
    preferred: false,
  };
